import { Route } from "@angular/router";
import { HistoriqueComponent } from "./historique.component";

export const HistoriqueRouting: Route = {
  path: 'historique',
  component: HistoriqueComponent,
  data: {
    breadcrumb: "Historique données statistiques"
  }
};
